import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LabBilingualCopy({ it, en }) {
  const { i18n } = useTranslation();
  const isItalian = i18n.language !== 'en';
  const text = isItalian ? it : en;

  return (
    <div className="lab-bilingual-copy">
      <p>{text}</p>
    </div>
  );
}
